import { RootState } from 'store/rootReducer';

export const LandingPageMarketingCardsContentSelector = (state: RootState) => state.content.landingPageMarketingCards;
